
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import i18n from '@/locales/init'; 
import style from './index.module.less';
export default function Loading({show}: {show: boolean;}) {
  return (
    show ? (
      <div className={style.loadingWrap}>
        <div className={style.loadContent}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: '#FFF' }} spin />} spinning={true}></Spin>
          <div className={style.text}>{i18n.t('common.dauyan_submiting')}</div>
        </div>
        
      </div>
    ) : null
  );
}